(function () {
  if (window.TrioEssencial) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var activeVideos = new Set();

  function $all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function once(el, key) {
    var flag = 'trio' + key;
    if (el.dataset[flag] === '1') return false;
    el.dataset[flag] = '1';
    return true;
  }

  function headerOffset() {
    var header = document.querySelector('.section-header');
    if (!header) return 16;
    var style = window.getComputedStyle(header);
    if (style.position === 'sticky' || style.position === 'fixed') return header.offsetHeight + 16;
    return 16;
  }

  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  /* ---------- Vídeos (inicialização tardia) ---------- */
  function pauseOthers(except) {
    activeVideos.forEach(function (video) {
      if (video !== except && !video.paused) video.pause();
    });
  }

  function mountVideo(wrapper, withSound) {
    var existing = wrapper.querySelector('video, iframe');
    if (existing) return existing;
    var tpl = wrapper.querySelector('template[data-trio-video-src]');
    if (!tpl) return null;
    var frame = tpl.parentNode;
    frame.insertBefore(tpl.content.cloneNode(true), tpl);
    var media = frame.querySelector('video, iframe');
    if (!media) return null;
    if (media.tagName === 'VIDEO') {
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      if (withSound) {
        media.muted = false;
        media.controls = true;
      } else {
        media.muted = true;
        media.setAttribute('muted', '');
      }
      activeVideos.add(media);
      media.addEventListener('play', function () {
        wrapper.classList.add('is-playing');
        if (!media.muted) pauseOthers(media);
      });
      media.addEventListener('ended', function () {
        if (!media.loop) wrapper.classList.remove('is-playing');
      });
    }
    return media;
  }

  function playWithSound(wrapper) {
    var media = mountVideo(wrapper, true);
    if (!media) return;
    wrapper.classList.add('is-playing');
    if (media.tagName !== 'VIDEO') return;
    media.muted = false;
    media.controls = true;
    wrapper.classList.add('is-unmuted');
    pauseOthers(media);
    var p = media.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideo(wrapper) {
    if (!once(wrapper, 'Video')) return;
    var playBtn = wrapper.querySelector('[data-trio-play]');
    var soundBtn = wrapper.querySelector('[data-trio-sound]');
    var wantsAutoplay = wrapper.dataset.autoplay === 'true' && !reduceMotion.matches;

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        playWithSound(wrapper);
        var media = wrapper.querySelector('video, iframe');
        if (media && media.focus) media.setAttribute('tabindex', '-1');
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        var video = wrapper.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        wrapper.classList.toggle('is-unmuted', !video.muted);
        soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        if (!video.muted) pauseOthers(video);
      });
    }

    if (!wantsAutoplay) return;
    wrapper.classList.add('is-autoplay');

    if (!hasIO) {
      var v = mountVideo(wrapper, false);
      if (v && v.play) v.play().catch(function () {});
      return;
    }

    var near = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      near.disconnect();
      var video = mountVideo(wrapper, false);
      if (!video || video.tagName !== 'VIDEO') return;
      video.preload = 'metadata';
      var view = new IntersectionObserver(function (items) {
        items.forEach(function (item) {
          if (item.isIntersecting && !document.hidden) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!video.paused && video.muted) {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      view.observe(wrapper);
    }, { rootMargin: '300px 0px' });
    near.observe(wrapper);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    activeVideos.forEach(function (video) { if (!video.paused) video.pause(); });
  });

  /* ---------- Galeria do hero ---------- */
  function initGallery(gallery) {
    if (!once(gallery, 'Gallery')) return;
    var track = gallery.querySelector('[data-trio-track]');
    if (!track) return;
    var slides = $all(track, '[data-trio-slide]');
    var dots = $all(gallery, '[data-trio-dot]');
    var thumbs = $all(gallery, '[data-trio-thumb]');
    var prev = gallery.querySelector('[data-trio-prev]');
    var next = gallery.querySelector('[data-trio-next]');
    var current = 0;
    var ticking = false;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function update() {
      ticking = false;
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      if (index === current && dots.length && dots[index] && dots[index].classList.contains('is-active')) return;
      current = index;
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
      slides.forEach(function (slide, i) {
        if (i === index) return;
        var video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
      });
      var label = gallery.querySelector('[data-trio-status]');
      if (label) label.textContent = (index + 1) + ' / ' + slides.length;
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    var dialog = gallery.querySelector('[data-trio-zoom]');
    var zoomImg = dialog ? dialog.querySelector('img') : null;
    var lastTrigger = null;

    $all(gallery, '[data-trio-zoom-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!dialog || !zoomImg || typeof dialog.showModal !== 'function') return;
        lastTrigger = btn;
        zoomImg.src = btn.dataset.zoomSrc;
        zoomImg.alt = btn.dataset.zoomAlt || '';
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
    });

    if (dialog) {
      var closeBtn = dialog.querySelector('[data-trio-zoom-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.classList.contains('trio-zoom__inner')) dialog.close();
      });
      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        if (lastTrigger) lastTrigger.focus({ preventScroll: true });
      });
    }

    update();
  }

  /* ---------- Carrossel UGC ---------- */
  function initCarousel(root) {
    if (!once(root, 'Carousel')) return;
    var track = root.querySelector('[data-trio-carousel-track]');
    if (!track) return;
    var bar = root.querySelector('[data-trio-progress]');
    var prev = root.querySelector('[data-trio-carousel-prev]');
    var next = root.querySelector('[data-trio-carousel-next]');
    var ticking = false;

    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var frac = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) {
        bar.style.width = Math.min(100, frac * 100) + '%';
        bar.style.transform = 'translateX(' + (track.clientWidth ? (track.scrollLeft / track.clientWidth) * 100 : 0) + '%)';
        bar.parentNode.hidden = max <= 2;
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    function step(dir) {
      var card = track.querySelector('[data-trio-card]');
      var amount = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- FAQ ---------- */
  function setPanel(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (open) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
  }

  function initFaq(root) {
    if (!once(root, 'Faq')) return;
    var single = root.dataset.single === 'true';
    var buttons = $all(root, '[data-trio-faq-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (open && single) buttons.forEach(function (other) { if (other !== btn) setPanel(other, false); });
        setPanel(btn, open);
      });
    });
  }

  /* ---------- Barra fixa mobile ---------- */
  var stickyState = null;

  function initSticky() {
    var bar = document.querySelector('[data-trio-sticky]');
    var primary = document.querySelector('[data-trio-primary-cta]');
    if (!bar || !primary || !hasIO) return;
    if (stickyState && stickyState.bar === bar) return;
    if (stickyState) stickyState.observer.disconnect();

    var state = { bar: bar, passed: false, visibleCtas: new Set(), ticking: false };

    function render() {
      var rect = primary.getBoundingClientRect();
      state.passed = rect.bottom < 0 || rect.top > window.innerHeight;
      var show = state.passed && state.visibleCtas.size === 0 && mobileQuery.matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('trio-sticky-on', show);
    }

    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) state.visibleCtas.add(entry.target);
        else state.visibleCtas.delete(entry.target);
      });
      render();
    }, { threshold: 0 });

    $all(document, '[data-trio-cta]').forEach(function (cta) {
      if (!bar.contains(cta)) state.observer.observe(cta);
    });
    window.addEventListener('scroll', function () {
      if (state.ticking || stickyState !== state) return;
      state.ticking = true;
      window.requestAnimationFrame(function () {
        state.ticking = false;
        render();
      });
    }, { passive: true });
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', render);
    stickyState = state;
    render();
  }

  /* ---------- Navegação rápida (desktop) ---------- */
  var navState = null;

  function initNav() {
    var nav = document.querySelector('[data-trio-nav]');
    if (!nav || !hasIO) return;
    if (navState && navState.nav === nav) return;
    if (navState) navState.observers.forEach(function (o) { o.disconnect(); });
    var state = { nav: nav, observers: [], passed: !document.querySelector('[data-trio-hero]'), visibleCtas: new Set() };
    var hero = document.querySelector('[data-trio-hero]');
    var links = $all(nav, 'a[href^="#"]');

    function renderNav() {
      var show = state.passed && state.visibleCtas.size === 0;
      nav.classList.toggle('is-visible', show);
      nav.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) nav.removeAttribute('inert'); else nav.setAttribute('inert', '');
    }

    if (hero) {
      var heroObs = new IntersectionObserver(function (entries) {
        state.passed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        renderNav();
      }, { threshold: 0 });
      heroObs.observe(hero);
      state.observers.push(heroObs);
    }

    var ctaObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) state.visibleCtas.add(entry.target);
        else state.visibleCtas.delete(entry.target);
      });
      renderNav();
    }, { threshold: 0 });
    $all(document, '[data-trio-cta]').forEach(function (cta) {
      if (!cta.closest('[data-trio-sticky]')) ctaObs.observe(cta);
    });
    state.observers.push(ctaObs);
    renderNav();

    var targets = links.map(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      return id ? document.getElementById(id) : null;
    });
    var sectionObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (link, i) {
          link.classList.toggle('is-active', targets[i] === entry.target);
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach(function (t) { if (t) sectionObs.observe(t); });
    state.observers.push(sectionObs);
    navState = state;
  }

  /* ---------- Revelação suave ---------- */
  var revealObserver = null;

  function initReveal(root) {
    if (designMode || reduceMotion.matches || !hasIO) return;
    document.documentElement.classList.add('trio-anim');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    $all(root, '.trio-reveal:not(.is-in)').forEach(function (el) {
      if (once(el, 'Reveal')) revealObserver.observe(el);
    });
  }

  /* ---------- Âncoras internas ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.trio-section a[href^="#"], .trio-nav a[href^="#"]');
    if (!link) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    scrollToTarget(target);
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  function selectVariant(id) {
    $all(document, '[data-trio-variant-input]').forEach(function (input) { input.value = id; });
    $all(document, '[data-trio-variant-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-trio-variant-panel') !== id;
    });
    if (history.replaceState && window.URL) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url.toString());
    }
  }

  function initOffers(fieldset) {
    if (!once(fieldset, 'offers')) return;
    fieldset.addEventListener('change', function (e) {
      if (e.target.matches('[data-trio-offer-input]')) selectVariant(e.target.value);
    });
  }

  function init(root) {
    root = root || document;
    $all(root, '[data-trio-offers]').forEach(initOffers);
    $all(root, '[data-trio-video]').forEach(initVideo);
    $all(root, '[data-trio-gallery]').forEach(initGallery);
    $all(root, '[data-trio-carousel]').forEach(initCarousel);
    $all(root, '[data-trio-faq]').forEach(initFaq);
    initSticky();
    initNav();
    initReveal(root);
  }

  window.TrioEssencial = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    stickyState = null;
    navState = null;
    init(e.target);
  });
})();
